import { createAction } from 'redux-actions'

const ns = 'language/'

export const changeUserLanguage = createAction(`${ns}CHANGE_USER_LANGUAGE`)
export const changeUserLanguageSuccess = createAction(`${ns}CHANGE_USER_LANGUAGE_SUCCESS`)
export const changeUserLanguageFail = createAction(`${ns}CHANGE_USER_LANGUAGE_FAIL`)
